import React from 'react';
import { Link } from 'react-router-dom';
import '../App.css'; // Make sure you have a CSS file for styling

const Footer = () => {
  return (
    <footer className="footer-container">
      <p>&copy; 2025 MTBFEED. All rights reserved.</p>
      <nav className="footer-navigation">
        <Link to="/feed" className="footer-link">Home</Link> |{' '}
        <Link to="/tos" className="footer-link">Terms of Service</Link> |{' '}
        <Link to="/privacypolicy" className="footer-link">Privacy Policy</Link> |{' '}
        <a href="mailto:editor@mtbfeed.com" className="footer-link">Contact</a> |{' '}
        <a href="mailto:editor@mtbfeed.com?subject=Advertising Inquiry" className="footer-link">Advertising</a>
      </nav>
    </footer>
  );
};

export default Footer;